// extracted by mini-css-extract-plugin
export default {"title":"OLecWrTw_6","tall":"_3jgh0jZv6c"};
    if(module.hot) {
      // 1627035466719
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  